import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Col, Grid } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { LineColorForm } from './LineColorForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LineColorAPI } from '../../../api/datamanager/LineColorAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

export class LineColors extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
    }

    constructor(props) {
        super(props);
        this.state = {
            lineColors: [],
            lineColorSelected: undefined,
            showLineColorForm: false,
            showDeleteModal: false,
            showExecutingModal: false,
            filter: "",
            nameInputError: null,
            backColorInputError: null,
            foreColorInputError: null,
            title: '',
            currentPage: 1,
            elementsPerPage: 10,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            loading: true
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        
        this.getLineColors();
    }

    // ----------------------

    getLineColors() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        let lineColorSelectedId = typeof this.state.lineColorSelected !== 'undefined' ? this.state.lineColorSelected.id : undefined;

        LineColorAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const totalPages = PaginationHelper.getTotalPages(data.length, this.state.elementsPerPage);
                this.setState({
                    lineColors: data,
                    currentPage: this.state.currentPage > totalPages ? totalPages : this.state.currentPage,
                    lineColorSelected: typeof lineColorSelectedId !== 'undefined' ? data.filter(lineColor => lineColor.id === lineColorSelectedId)[0] : undefined,
                    nameInputError: null,
                    backColorInputError: null,
                    foreColorInputError: null,
                    showLineColorForm: false,
                    showDeleteModal: false,
                    showExecutingModal: false,
                    loading: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    errorLoading: true,
                })
            });
    }

    updateLineColorValue = (e, value) => {
        let { lineColorSelected } = this.state;

        if (value === 'backColor' || value === 'foreColor') {
            lineColorSelected[value] = e.rgb;
        } else {
            lineColorSelected[value] = e.target.value;
        }

        this.setState({
            lineColorSelected
        })
    }

    createShadeValue = (shade) => {
        let { lineColorSelected } = this.state;

        if (lineColorSelected.shades.length < 5) {
            if (shade.val !== undefined) {
                lineColorSelected.shades.push(shade);
            }
        } else {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: 'O limite de 5 tonalidades por cor foi atingido.',
                alertStyle: 'warning',
                icon: 'alert',
                showErrorModal: true
            })
        }

        this.setState({
            lineColorSelected
        })
    }

    editShadeValue = (shade, index) => {
        let { lineColorSelected } = this.state;

        if (shade !== undefined) {
            lineColorSelected.shades[index].val = shade.rgb !== undefined ? shade.rgb : shade;
        }

        this.setState({
            lineColorSelected
        })
    }

    removeShadeValue = (index) => {
        let { lineColorSelected } = this.state;

        lineColorSelected.shades.splice(index, 1);

        this.setState({
            lineColorSelected
        })
    }

    saveLineColor = () => {
        if (this.state.lineColorSelected.id !== undefined) {

            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    LineColorAPI.update(this.state.lineColorSelected.id, this.state.lineColorSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Cor alterada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                lineColorSelected: undefined,
                                showErrorModal: true
                            });
                            this.getLineColors();
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        })
                });
            }
        } else {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    LineColorAPI.create(this.state.lineColorSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: 'Sucesso',
                                alertMessage: 'Cor criada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: 'Erro',
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.getLineColors();
                        })
                });
            }
        }
    }

    validInput() {
        let { nameInputError, backColorInputError, foreColorInputError } = this.state;
        let errors = 0;

        nameInputError = null;
        backColorInputError = null;
        foreColorInputError = null;

        if (this.state.lineColorSelected.name === "") {
            nameInputError = 'error';
            errors++;
        }

        if (this.state.lineColorSelected.backColor === "") {
            backColorInputError = 'error';
            errors++;
        }

        if (this.state.lineColorSelected.foreColor === "") {
            foreColorInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError,
            backColorInputError,
            foreColorInputError
        })

        return errors > 0 ? false : true;
    }

    deleteLineColor = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                LineColorAPI.delete(this.state.lineColorSelected.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Cor removida com sucesso.',
                            alertStyle: 'success',
                            icon: 'ok',
                            showErrorModal: true
                        });
                        this.getLineColors();
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        });
                        this.getLineColors();
                    })
            });
        }

        this.setState({
            showDeleteModal: false
        })
    }

    handleCreateClick = () => {
        this.setState({
            lineColorSelected: {
                name: "", backColor: "", foreColor: "", shades: []
            },
            showLineColorForm: true,
            title: 'Criar'
        })
    }

    handleEditClick = (color) => {
        this.setState({
            lineColorSelected: color,
            showLineColorForm: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (color) => {
        this.setState({
            lineColorSelected: color,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar a cor ${color.name}?`,
            icon: 'alert',
            alertStyle: "warning"
        })
    }

    clearError = () => {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    renderColorsTable(colors) {
        const { currentPage, elementsPerPage, filter } = this.state;

        const colorsFiltered = SearchHelper.search({
            filter: filter,
            data: colors,
            fields: ["name"]
        });
        const totalPages = PaginationHelper.getTotalPages(colorsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const colorsToRender = colorsFiltered.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Cor Fundo</th>
                            <th>Cor Texto</th>
                            <th>Tonalidades</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            colorsToRender.map((lineColor, idx) =>
                                <tr key={`linecolor-${idx}`}>
                                    <td>{lineColor.name}</td>
                                    <td>
                                        {
                                            typeof lineColor !== 'undefined'
                                                ?
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${lineColor.backColor.r}, ${lineColor.backColor.g}, ${lineColor.backColor.b}, ${lineColor.backColor.a})`
                                                        }
                                                    }
                                                />
                                                :
                                                ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            typeof lineColor !== 'undefined'
                                                ?
                                                <span className="span-colors"
                                                    style={
                                                        {
                                                            backgroundColor: `rgba(${lineColor.foreColor.r}, ${lineColor.foreColor.g}, ${lineColor.foreColor.b}, ${lineColor.foreColor.a})`
                                                        }
                                                    }
                                                />
                                                :
                                                ''
                                        }
                                    </td>
                                    <td>
                                        {
                                            lineColor.shades.length !== 0
                                                ?
                                                lineColor.shades.map((sh, i) =>
                                                    sh !== undefined
                                                        ?
                                                        i === 0
                                                            ?
                                                            <span key={`gradient-${i}`} className="span-colors-gradients"
                                                                style={
                                                                    {
                                                                        backgroundColor: `rgba(${sh.val.r}, ${sh.val.g}, ${sh.val.b}, ${sh.val.a})`
                                                                    }
                                                                }
                                                            />
                                                            :
                                                            <span key={`gradient-${i}`} className={"span-colors-gradients margin-left--10 span-colors-gradients-zindex-" + i}
                                                                style={
                                                                    {
                                                                        backgroundColor: `rgba(${sh.val.r}, ${sh.val.g}, ${sh.val.b}, ${sh.val.a})`
                                                                    }
                                                                }
                                                            />
                                                        :
                                                        null
                                                )
                                                :
                                                null
                                        }
                                    </td>
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(lineColor)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(lineColor)} />
                                        </ButtonToolbar>
                                    </td>

                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={currentPage}
                    elementsPerPage={elementsPerPage}
                    dataLength={colorsFiltered.length}
                    onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            let contents = this.state.loading
                ? <LoadingSpinner />
                : this.renderColorsTable(this.state.lineColors);

            return (
                <div>
                    {
                        this.state.loading
                            ?
                            null
                            :
                            <TitleRow title="Cores" showSeparator={true}>
                                <Col className="padding-0" xs={2} sm={1} md={4}>
                                    <ButtonToolbar className="pull-right title-row-col-btns">
                                        <Button onClick={this.handleCreateClick}>CRIAR</Button>
                                    </ButtonToolbar>
                                </Col>
                                <Col className="padding-0" xs={10} sm={11} md={8}>
                                    <div className="search-bar">
                                        <SearchBar onSearch={(a) => this.onSearch(a)} />
                                    </div>
                                </Col>
                            </TitleRow>
                    }
                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <LineColorForm show={this.state.showLineColorForm} title={this.state.title} onSave={this.saveLineColor} lineColor={this.state.lineColorSelected} onHide={() => this.getLineColors()}
                        onChangeValue={this.updateLineColorValue} onCreateShadeValue={this.createShadeValue} onEditShadeValue={this.editShadeValue} onRemoveShadeValue={this.removeShadeValue} nameInputError={this.state.nameInputError} backColorInputError={this.state.backColorInputError}
                        foreColorInputError={this.state.foreColorInputError} />

                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteLineColor} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal && false === this.state.showExecutingModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            );
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lineColors/LineColors.js